import errorDeliveryImage from "./assets/images/error/error-delivery.jpg";
import errorDeliveryImage2x from "./assets/images/error/error-delivery@2x.jpg";
import errorDeliveryImage3x from "./assets/images/error/error-delivery@3x.jpg";
import favicon from "./assets/images/brand-favicon.ico";
import logoImage from "./assets/images/brand-logo.svg";
import logoMini from "./assets/images/logo-mini.png";
import logoMiniLight from "./assets/images/logo-mini-light.png";
import logoImageLight from "./assets/images/brand-logo-light.svg";
import noDataImage from "./assets/images/nodata-image.png";
import onboardingWelcomeStartModal from "./assets/images/onboarding/onboarding-welcome-start-modal.jpg";
import statusError from "./assets/images/status/status-error.jpg";
import statusSuccess from "./assets/images/status/status-success.jpg";
import reportsBag from "./assets/images/reportsConstructor/reports-bag.png";
import reportsInf from "./assets/images/reportsConstructor/reports-inf.png";
import reportsLock from "./assets/images/reportsConstructor/reports-lock.png";
import reportsPhones from "./assets/images/reportsConstructor/reports-phones.png";
import reportsRub from "./assets/images/reportsConstructor/reports-rub.png";
import reportsSim from "./assets/images/reportsConstructor/reports-sim.png";
import reportsSubs from "./assets/images/reportsConstructor/reports-subs.png";
import calendarWithBackground from "./assets/images/calendar-with-background.svg";
import download from "./assets/images/download.svg";
import filter from "./assets/images/filter.svg";
import bell from "./assets/images/bell.svg";
import supportMessage from "./assets/images/support-message.svg";
import errorBig from "./assets/images/error-big.png";
import profile from "./assets/images/profile.svg";
import supportAvatar from "./assets/images/support-avatar.svg";
import arrowRightInfo from "./assets/images/arrow-right-info_small.svg";
import arrowButton from "./assets/images/arrow_button.svg";
import arrowDown from "./assets/images/arrow_down.svg";
import avatar from "./assets/images/avatar.svg";
import cancel from "./assets/images/cancel.svg";
import close from "./assets/images/close.svg";
import dots from "./assets/images/dots.svg";
import dotsOutlined from "./assets/images/dots-outline.svg";
import downloadLink from "./assets/images/download-link-icon.svg";
import edit from "./assets/images/edit.svg";
import info from "./assets/images/info.svg";
import infoFilled from "./assets/images/info_filled.svg";
import menu from "./assets/images/menu.svg";
import people from "./assets/images/people.svg";
import sortingDefault from "./assets/images/sorting-default-icon.svg";
import sortingDown from "./assets/images/sorting-down-icon.svg";
import sortingUp from "./assets/images/sorting-up-icon.svg";
import dividerVertical from "./assets/images/divider_vertical.svg";
import refresh from "./assets/images/refresh.svg";
import success from "./assets/images/success.png";

export {
    errorDeliveryImage,
    errorDeliveryImage2x,
    errorDeliveryImage3x,
    favicon,
    logoImage,
    logoMini,
    logoMiniLight,
    logoImageLight,
    noDataImage,
    onboardingWelcomeStartModal,
    statusError,
    statusSuccess,
    reportsBag,
    reportsInf,
    reportsLock,
    reportsPhones,
    reportsRub,
    reportsSim,
    reportsSubs,
    calendarWithBackground,
    download,
    filter,
    bell,
    supportMessage,
    errorBig,
    supportAvatar,
    profile,
    arrowRightInfo,
    arrowButton,
    arrowDown,
    avatar,
    cancel,
    close,
    dots,
    dotsOutlined,
    downloadLink,
    edit,
    info,
    infoFilled,
    menu,
    sortingDefault,
    people,
    sortingDown,
    sortingUp,
    dividerVertical,
    refresh,
    success,
};
